import React, { useEffect, useState } from 'react';
import {
  Button,
  Paper,
  Typography,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  InputAdornment,
  Tabs,
  Tab,
  Box,
  Chip,
  Grid,
  Card,
  CardContent,
  Divider,
  IconButton,
  Tooltip,
  CircularProgress
} from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { 
  currencyFormat, 
  isEven, 
  daysOfTheWeek, 
  mtcFrequencies,
} from '../../../../services/common';
import { connect } from 'react-redux';
import axios from 'axios';
import SearchIcon from '@material-ui/icons/Search';
import EditIcon from '@material-ui/icons/Edit';
import AssignmentIcon from '@material-ui/icons/Assignment';
import WarningIcon from '@material-ui/icons/Warning';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import moment from 'moment';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import TrendingDownIcon from '@material-ui/icons/TrendingDown';
import RemoveIcon from '@material-ui/icons/Remove';

import {
  calculateMonthlyValue,
  StarRating,
  isSiteDueForReview,
  isOverdue,
  getSiteReviewMetrics
} from './utils'

const RowDetails = ({
  key,
  handleOpenSite,
  site,
  siteReviews,
}) => {
  const classes = useStyles()
    return (
      <TableRow 
        key={key} 
        className={classes.tableRow}
        onDoubleClick={() => handleOpenSite(site)}
      >
        {/* Keep existing cells */}
        <TableCell>{site.clientName}</TableCell>
        <TableCell>{site.name}</TableCell>
        <TableCell>{site.jobName}</TableCell>
        <TableCell>{site.customerType}</TableCell>
        <TableCell>
          {site.communityName ? `${site.communityName} ` : ''}
          {site.address}
          {site.buildingNumber ? ` ${site.buildingNumber}` : ''}
        </TableCell>
        <TableCell>
          <PreferredDays site={site} />
        </TableCell>
        <TableCell>{site.frequency}</TableCell>
        <TableCell>{site.evenOrOddWeeks || ''}</TableCell>
        <TableCell>
          <div style={{ display: 'flex', flexDirection: 'column'}}>
            {
                <div>
                {site.monthlyValue ? `${currencyFormat(site.monthlyValue)}/mo` : ''} 
                </div>
              }
              <div>
                {site.amountType === 'perCrewPerDay' && site.laborDetails?.length > 0 && (
                        <Box className={classes.reviewScore}>
                          <Tooltip title={
                            <div className={classes.tooltipContent}>
                              <div style={{ fontWeight: 300, color: '#fff', fontSize: '0.95em', lineHeight: 1.4 }}>
                                {site.laborDetails.map((item, idx) => {
                                  const hours = parseFloat(item.hoursPerVisit || 0);
                                  const men = parseInt(item.numberOfMen || 0);
                                  const rate = parseFloat(item.ratePerHour || 0);
                                  const laborLabel = item.laborType.charAt(0).toUpperCase() + item.laborType.slice(1);
                                  console.log('Hours %s  Men %s  Rate %s Label %s ', hours, men, rate, laborLabel)
                                  return (
                                    <div key={item.id || idx}>
                                      {`${hours} Hours (${men} - ${laborLabel}) @ ${currencyFormat(rate)}/hr`}
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                      
                        }>
                          <Box>
                          <Box className={classes.ratingRow}>
                              <span style={{ fontWeight: 300, color: '#516e76', fontSize: '0.85em' }}>
                                
                              Per Person/Day
                    
                              </span>
                          </Box>
                    </Box>
                    </Tooltip>
                  </Box>
                )}
                {
                  site.amountType === 'perVisit' ? (
                    <span style={{ fontWeight: 300, color: '#516e76', fontSize: '0.85em' }}>{site.amount ? currencyFormat(site.amount) : ''} Per Visit
                    
                    </span>
                  ) : ''
                }
                    
              </div>

              
          </div>
          
        </TableCell>
        <TableCell>
          {site.crew ? `${site.crewName}` : 'Unassigned'}
        </TableCell>
        
        {/* New Site Review Status Cell */}
        <TableCell>
        {renderReviewCell(site, siteReviews)}
        </TableCell>
      </TableRow>
  );
};

const renderReviewCell = (site, siteReviews) => {
  const classes = useStyles()
  // console.log('Review cell..', site.name)
  const { score, trend, hasIssues, daysAgo, detailedRatings } = getSiteReviewMetrics(site._id, siteReviews);
  
  if (!score) {
    return (
      <Typography variant="body2" color="textSecondary">
        No reviews
      </Typography>
    );
  }

  return (
    <Box className={classes.reviewScore}>
      <Tooltip title={
        <div className={classes.tooltipContent}>
          {detailedRatings.map((rating, idx) => (
            <div key={idx} className={classes.ratingRow}>
              <Typography variant="body2" style={{minWidth: '80px'}}>
                {rating.name}:
              </Typography>
              <StarRating rating={rating.rating} small />
              {rating.notes && (
                <Typography variant="caption" color="#eee">
                  - {rating.notes}
                </Typography>
              )}
            </div>
          ))}
        </div>
      }>
        <Box>
          <Box className={classes.ratingRow}>
            <StarRating rating={score} />
            {trend !== 'neutral' && (
              trend === 'up' ? <TrendingUpIcon color="primary" /> : <TrendingDownIcon color="error" />
            )}
            {hasIssues && (
              <Tooltip title={`Has outstanding issues`}>
                <WarningIcon className={classes.warningIcon} fontSize="small" />
              </Tooltip>
            )}
          </Box>
          <Typography className={classes.daysAgo}>
            {daysAgo}
          </Typography>
        </Box>
      </Tooltip>
    </Box>
  );
};

const PreferredDays = ({ site }) => {
  if (site && (site.frequency === 'Twice a Week' || site.frequency === 'Four Days Per Week')) {
    return site.preferredDays.join(', ')
  } else {
    return site.preferredDay
  }

}

export default RowDetails

const useStyles = makeStyles(theme => ({
  root: {
    margin: theme.spacing(2),
  },
  paper: {
    width: '100%',
    height: '100%',
    minHeight: '80vh',
    padding: theme.spacing(3),
  },
  headerRow: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    fontWeight: 'bold',
  },
  headerCell: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  headerContent: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  starIcon: {
    color: theme.palette.primary.main,
    fontSize: '1.2rem',
  },
  starIconSmall: {
    fontSize: '1rem',
  },
  warningIcon: {
    color: theme.palette.warning.main,
    marginLeft: theme.spacing(1),
  },
  reviewScore: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
  },
  ratingRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  daysAgo: {
    color: theme.palette.text.secondary,
    fontSize: '0.75rem',
  },
  sortIcon: {
    marginLeft: theme.spacing(1),
    transition: 'transform 0.2s',
  },
  tooltipContent: {
    padding: theme.spacing(1),
  }
}));
